import {BloomForWomen} from "./BloomForWomen";

declare var wp_ajax_object:any;
declare var window:any;
let bloomForWomen = new BloomForWomen(wp_ajax_object, window);
bloomForWomen.init();
window['bloom'] = bloomForWomen;

jQuery(document).ready(function () {

    // init slider on home page
    if (jQuery('#page-index, #page-trauma').length > 0) {
        jQuery('#slide-counter').prepend('<p class="current-index"></p>/');

        var slider = jQuery('.betrayal-trauma-slider').bxSlider({
            auto: true,
            controls: false,
            onSliderLoad: function (currentIndex:number) {
                jQuery('#slide-counter .current-index').text(currentIndex + 1);
            },
            onSlideBefore: function ($slideElement, oldIndex:number, newIndex:number) {
                jQuery('#slide-counter .current-index').text(newIndex + 1);
            }
        });
        let slideCount = slider.getSlideCount();
        jQuery('#slide-counter').append(slideCount.toString());
    }


    jQuery('#my-courses-toggle').click(function () {
        jQuery(this).toggleClass('open');
        jQuery('#my-courses').toggle();
    });

    jQuery('#categories-toggle').click(function () {
        jQuery(this).toggleClass('open');
        jQuery('#categories').toggle();
    });

    jQuery('.menu-item-has-children').on('click', function () {

        if (jQuery('.menu-item-has-children').hasClass('expanded')) {
            jQuery('.menu-item-has-children').removeClass('expanded');
        } else {
            jQuery(this).removeClass('expanded');
            jQuery(this).addClass('expanded');
        }
    });

    function featuredCoursePhoto() {
        var courseBoxHeight = jQuery('.course-box.featured .featured-info').outerHeight();
        jQuery('.course-box.featured .course-thumb').css('height', courseBoxHeight + 'px');
    }

    function checkFeaturedCourse() {
        if (jQuery('.course-box.featured .course-thumb').length > 0) {
            featuredCoursePhoto();
            return;
        }
        else {
            setTimeout(checkFeaturedCourse, 10);
        }
    }

    if (jQuery('#page-courses.courses-1-0').length > 0) {
        checkFeaturedCourse();
        // when we resize we load it
        jQuery(window).resize(function () {
            featuredCoursePhoto();
        });
        // when we've fully loaded we resize.
        jQuery(document).on('load', featuredCoursePhoto);
    }

    // Init jQuery UI for dropdowns
    //jQuery('#content-focus').selectmenu();
});
 
